// ============================================================================
// INVENTORY (Devices)
// ============================================================================

export type ABMStatus = 'ABM' | 'NO ENROLADA' | 'No Aplica' | 'Vendida';

export interface Device {
  deviceId: string;

  // Campos del Excel columnas A-O
  fechaCompra?: string;           // ISO 8601 date
  proveedor?: string;             // Proveedor
  numFactura?: string;            // Num. Factura
  costo?: number;                 // Costo
  linkFactura?: string;           // Link Factura (URL)
  clapBase: string;               // ClapBase location
  nroReferencia?: string;         // Nro Referencia
  categoria: string;              // Categoria (Laptop Mac, Laptop, etc)
  modelo: string;                 // Modelo
  nroModelo?: string;             // Nro de Modelo del fabricante (ej: MK183LL/A)
  nroSerie: string;               // Nro de Serie - UNIQUE
  procesador?: string;            // Procesador
  ramGB?: number;                 // RAM (gb)
  discoGB?: number;               // Disco (gb)
  abm?: ABMStatus;                // ABM status
  status: string;                 // Status
  owner?: string;                 // Owner
  comments?: string;              // Comments
  observaciones?: string;         // Observaciones (el zod del router las acepta hace rato)

  // QuipTeams integration
  quipteamsOrderId?: string;  // set when device was purchased via QuipTeams

  // Metadata
  createdAt: string;
  updatedAt: string;
  createdBy?: string;

  // ABM data enrichment (populated from join)
  abmData?: ABMData;
}

export interface ABMData {
  serialNumber: string;
  deviceId?: string;
  modelName?: string;
  deviceCapacity?: string;
  dateAddedToOrganization?: string;
  rawData?: Record<string, any>;
  linkedDeviceId?: string;
  uploadedAt: string;
  uploadedBy?: string;
}

export interface CreateDeviceInput {
  fechaCompra?: string;
  proveedor?: string;
  numFactura?: string;
  costo?: number;
  linkFactura?: string;
  clapBase: string;
  nroReferencia?: string;
  categoria: string;
  modelo: string;
  nroModelo?: string;
  nroSerie: string;
  procesador?: string;
  ramGB?: number;
  discoGB?: number;
  abm?: ABMStatus;
  status: string;
  owner?: string;
  comments?: string;
  quipteamsOrderId?: string;
}

export interface UpdateDeviceInput extends Partial<CreateDeviceInput> {
  deviceId: string;
}

export interface InventoryOption {
  optionType: 'clapbase' | 'categoria' | 'modelo' | 'status' | 'proveedor' | 'techMember' | 'financeMember';
  value: string;
  isActive: boolean;
  usageCount: number;
  createdAt: string;
  createdBy: string;
}

export interface CreateInventoryOptionInput {
  optionType: 'clapbase' | 'categoria' | 'modelo' | 'status' | 'techMember' | 'financeMember';
  value: string;
}

export interface DeviceFilters {
  clapBase?: string[];
  categoria?: string[];
  status?: string[];
  search?: string;
  abmStatus?: ABMStatus[];
}

export interface ABMUploadResult {
  totalRows: number;
  successfulUploads: number;
  linkedDevices: number;
  errors: string[];
}

// Legacy - Keep for backwards compatibility with existing code
export type Computer = Device;
export type CreateComputerInput = CreateDeviceInput;
export type UpdateComputerInput = UpdateDeviceInput;

/**
 * Estados de `abm_assignment` en UserAltasTable (asignación del alta a Apple
 * Business, barrido diario AbmAssignmentService). Fuente única: los lee el
 * backend y el pipeline de Altas del front.
 *  - pendiente: la persona todavía no apareció en Apple Business (sync de Google)
 *  - asignado: en el blueprint Winclap Y en algún grupo de usuarios
 *  - asignado_sin_grupo: en el blueprint pero en ningún grupo → en la práctica la
 *    Mac no enrola hasta que alguien lo agregue a su grupo en business.apple.com
 *  - 'error: …' (string libre) cuando Apple falló
 */
export const ABM_ASSIGNMENT = {
  PENDING: 'pendiente',
  ASSIGNED: 'asignado',
  ASSIGNED_NO_GROUP: 'asignado_sin_grupo',
} as const;
export type AbmAssignmentStatus = (typeof ABM_ASSIGNMENT)[keyof typeof ABM_ASSIGNMENT];
